const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/route.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { backlogItemsDataSetFetchOptions } from '@/lib/queries/adaptive-planner/useFetchBacklogItemsDataSet';
import { itemsDataSetQueryOptions } from '@/lib/queries/common/useGetItemsDataSetQuery';
import { backlogItemsFilterSearchSchema } from '@/lib/zod-schemas/backlogItemsFilterSearchSchema';
import { descendantItemFilterSearchSchema } from '@/lib/zod-schemas/descendantItemFilterSearchSchema';
import { itemFilterSearchSchema } from '@/lib/zod-schemas/itemFilterSearchSchema';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
const backlogSearchSchema = itemFilterSearchSchema.and(itemPanelSearchSchema).and(descendantItemFilterSearchSchema).and(backlogItemsFilterSearchSchema);
export const Route = createFileRoute('/(app)/org/$org/adaptive-planner/plan/$planId/backlog')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(backlogSearchSchema),
  loader: async ({
    context: {
      queryClient
    },
    params: {
      planId
    }
  }) => {
    const planNum = Number(planId);
    await queryClient.ensureQueryData(itemsDataSetQueryOptions({
      filter: {
        'descendant.statusItemStatusType': {
          value: ['IN_PROGRESS', 'TO_DO'],
          operator: 'in'
        }
      }
    }));
    await queryClient.ensureQueryData(backlogItemsDataSetFetchOptions({
      planId: planNum
    }));
  },
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});